import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GlobalService } from '../../services/global/global.service';
import { UserService } from '../../services/user/user.service';
import { SessionInterface } from '../../interfaces/session/session.interface';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

  public dashboardUrl: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private globalService: GlobalService,
    private userService: UserService
  ) {}

  public ngOnInit(): void {
    this.globalService.updateMenuLink('dashboard');
    this.userService.getSessionDatas().subscribe((sessionData: SessionInterface) => {
      if (sessionData !== undefined) {
        this.dashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://dataviz.firsteco.fr/dashboard_firsteco/?token=${sessionData.customerDetails.dashboard_token}`
        );
      }
    });
  }
}
